import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'ui-components/components/checkbox';
import { FormattedMessage } from 'react-intl';
import InputValueProps from '../../../../../prop-types/input-value-props';
import sharedStyles from '../../../../../style.module.less';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import UnexpectedValueComponent from './unexpected-value';
import classnames from 'classnames';
import { PARAMETER } from '../../../../../constants/parameter-name-for-update';
import messages from './messages';
import style from './style.module.less';

const CollectPaymentOnDelivery = ({ inputValueProps, onChange }) => {
  const { parameter } = inputValueProps;
  const valueParts = parameter?.toString().split(',') || [];
  const isNewAction = parameter === undefined;
  const [paymentType, setPaymentType] = useState(valueParts[0]);
  const [amount, setAmount] = useState(valueParts[1]);
  const [useOrderTotal, setUseOrderTotal] = useState(valueParts[2] === 'true');
  const valueDoesNotConformToStandard = !isNewAction && valueParts.length !== 3;

  const paymentTypes = [
    {
      id: 'any',
      name: messages.payTypeAny,
    },
    {
      id: 'cash',
      name: messages.payTypeCash,
    },
    {
      id: 'guaranteed_funds',
      name: messages.payTypeMoneyOrder,
    },
  ];
  const setActionValue = useCallback(() => {
    onChange({
      [PARAMETER]: `${paymentType},${amount},${useOrderTotal}`,
    });
  }, [onChange, paymentType, amount, useOrderTotal]);
  const onUseOrderTotalChange = useCallback(
    (val) => {
      setUseOrderTotal(val);
      onChange({
        [PARAMETER]: `${paymentType},${amount},${val}`,
      });
    },
    [setUseOrderTotal, onChange, paymentType, amount],
  );
  const onSetAmount = useCallback(
    (e) => {
      setAmount(e?.target?.value);
    },
    [setAmount],
  );

  const selectedPayType = paymentTypes.find((t) => t.id === paymentType);
  if (valueDoesNotConformToStandard) {
    return <UnexpectedValueComponent />;
  }
  return (
    <div className={style['multi-control']}>
      <div className={style['multi-control-row']}>
        <div>
          <FormattedMessage {...messages.codPaymentType} />
        </div>
        <div>
          <DropdownMenu className={sharedStyles['dropdown-menu']} dropdownMenuShouldHaveWidthOfButton>
            <DropdownMenuToggler className={sharedStyles['dropdown-toggler']}>
              {selectedPayType && <FormattedMessage {...selectedPayType.name} />}
              {!selectedPayType && <FormattedMessage {...messages.noOptionSelectedMessage} />}
            </DropdownMenuToggler>
            {paymentTypes.map((payType) => {
              return (
                <DropdownMenuItem
                  key={payType.id}
                  className={sharedStyles['dropdown-item']}
                  onClick={() => setPaymentType(payType.id)} // TODO: remove anon when dropdown supports typing for a further nested element
                  theme='unstyled'
                >
                  <FormattedMessage {...payType.name} />
                </DropdownMenuItem>
              );
            })}
          </DropdownMenu>
        </div>
      </div>
      <div className={classnames(style.stacked, style['multi-control-row'])}>
        <div>
          <FormattedMessage {...messages.codPaymentAmount} />
        </div>
        <div>
          <input
            className={style['text-input']}
            disabled={useOrderTotal}
            onBlur={setActionValue}
            onChange={onSetAmount}
            value={useOrderTotal ? '' : amount}
          />
        </div>
      </div>
      <div className={style['multi-control-row']}>
        <div className={style['checkbox-wrap']}>
          <Checkbox checked={useOrderTotal} onChange={onUseOrderTotalChange}>
            <span className={style.checkbox}>
              <FormattedMessage {...messages.codPaymentUseOrderTotal} />
            </span>
          </Checkbox>
        </div>
      </div>
    </div>
  );
};

CollectPaymentOnDelivery.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CollectPaymentOnDelivery;
